<template>
  <div id="app">

            <wpmenu></wpmenu>

                <div class="container main-content">

                      <div id="content">
                        <router-view></router-view>
                      </div>

                </div>
 <wpfooter></wpfooter>



  </div>
</template>

<script>

import wpfooter from './components/global/Footer.vue'
import wpmenu from './components/global/Menu.vue'
import metadata from './components/global/metadata.vue'


export default {
  name: 'app',

  components: {

    wpfooter,
    wpmenu,
      metadata
  }

}
</script>

<style src="./sass/global.scss" lang="scss"></style>
